import MessagePostback from "./MessagePostback";
export default MessagePostback;
